import { Component, Input, OnInit } from '@angular/core'
import { FrontendLanguageBridge } from '../../bridges/frontend-language-bridge.js'
import type { LanguageSwitcherText, LanguageSwitcherType } from '@lg/shared'

@Component({
	selector: 'lowgile-language-switcher',
	templateUrl: './language-switcher.component.html',
	standalone: false,
})
export class LanguageSwitcherComponent implements OnInit {
	@Input({ required: true }) languageBridge!: typeof FrontendLanguageBridge
	@Input() texts: LanguageSwitcherText = 'shortNames'
	@Input() type: LanguageSwitcherType = 'pipeSeparated'

	languageList: [string, string][] = []

	ngOnInit() {
		this.languageList = this.languageBridge.languages.map(([id, info]) => {
			if (this.texts == 'shortNames') return [id, info.shortName]
			if (this.texts == 'displayNames') return [id, info.displayName]
			return [id, id]
		})
	}

	async setLanguage(language: string) {
		this.languageBridge.language = language
		await (globalThis as any).System.UserLanguage.set(language)
	}
}
